import { render, staticRenderFns } from "./gzyqsbbb.vue?vue&type=template&id=1b20f18b&scoped=true"
import script from "./gzyqsbbb.vue?vue&type=script&lang=js"
export * from "./gzyqsbbb.vue?vue&type=script&lang=js"
import style0 from "./gzyqsbbb.vue?vue&type=style&index=0&id=1b20f18b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20f18b",
  null
  
)

export default component.exports